import { ChangeDetectorRef, Component, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
  IonRouterOutlet,
  LoadingController,
  MenuController,
  ModalController,
  NavController,
  Platform,
  PopoverController,
} from '@ionic/angular';

import { AccountsService } from './core/services/accounts/accounts.service';
import { Subject, Subscription } from 'rxjs';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { filter, takeUntil } from 'rxjs/operators';
import { EventMessage, EventType } from '@azure/msal-browser';
import { StorageService } from './core/services/storage/storage.service';
import { Device, DeviceInfo } from '@capacitor/device';
import { CustomNavigationClient } from './core/services/msal/customNavigationClient';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { ActivatedRoute, Router } from '@angular/router';
import { DomainService } from './core/services/domain/domain.service';
import { SharedService } from './core/services/shared/shared.service';
import { LoginAccountService } from './core/services/login-account/login-account.service';
import { WebAppInfo } from '@app/core/constants/web-versions';
import { App } from '@capacitor/app';
import { LanguageService } from './core/services/language/language.service';

import { UpdatePwaServiceService } from './core/services/updatePwaService/update-pwa-service.service';
import { FirebaseCrashlyticsService } from './core/services/firebase-crashlytics/firebase-crashlytics.service';
import { GoogleAuth } from '@codetrix-studio/capacitor-google-auth';
import { environment } from '@env';
import { IntuneService } from './core/services/intune/intune.service';
import { MobileConfiguration } from './shared/interfaces/intune.interface';
import { DrivePickerService } from './core/services/drive-picker/drive-picker.service';
import { ToastService } from './core/services/toast/toast.service';
import { TranslateService } from '@ngx-translate/core';
// const { version } = require("./../../package.json");

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: [
    './styles/side-menu.scss',
    './styles/side-menu.shell.scss',
    './styles/side-menu.responsive.scss',
  ],
})
export class AppComponent implements OnInit, OnDestroy {
  @ViewChild(IonRouterOutlet) routerOutlet: IonRouterOutlet;
  public backCount: number = 0;
  appPages = [
    {
      title: 'Add Accounts',
      url: '/app/user',
      ionicIcon: 'person-outline',
    },
  ];
  accountPages = [
    // {
    //   label: 'GoogleDrive',
    //   title: "Google Drive",
    //   url: "/auth/login",
    //   ionicIcon: "cloud-outline",
    //   isEnabled: false,
    //   isVisible: true
    // },
    {
      label: 'Box',
      title: 'Box',
      url: '/auth/login',
      ionicIcon: 'cloud-outline',
      isEnabled: false,
      isVisible: true,
    },
    {
      label: 'OneDrive',
      title: 'One Drive',
      url: '/auth/login',
      ionicIcon: 'cloud-outline',
      isEnabled: false,
      isVisible: true,
    },
    {
      label: 'DropBox',
      title: 'Drop Box',
      url: '/getting-started',
      ionicIcon: 'cloud-outline',
      isEnabled: false,
      isVisible: true,
    },
    {
      label: 'Office365',
      title: 'Office 365',
      url: '/getting-started',
      ionicIcon: 'cloud-outline',
      isEnabled: false,
      isVisible: true,
    },
  ];

  gDrive = true;
  oneDrive = false;
  box = false;
  dropBox = false;
  office365 = false;

  textDir = 'ltr';
  deviceInfo: DeviceInfo;
  appVersion: string;
  cloudStorageToggle = true;
  subscription: Subscription;

  private readonly _destroying$ = new Subject<void>();
  constructor(
    private accountSvc: AccountsService,
    private menuCtrl: MenuController,
    private navCtrl: NavController,
    private broadcastService: MsalBroadcastService,
    private accounts: AccountsService,
    private storageSvc: StorageService,
    private iab: InAppBrowser,
    private msalService: MsalService,
    public loadingCtrl: LoadingController,
    private domainSvc: DomainService,
    private platform: Platform,
    private route: ActivatedRoute,
    public sharedSvc: SharedService,
    public loginAccountService: LoginAccountService,
    private webAppInfo: WebAppInfo,
    private updatePwaServiceService: UpdatePwaServiceService,
    private languageService: LanguageService,
    private zone: NgZone,
    private firebaseCrashlyticsService: FirebaseCrashlyticsService,
    public intuneService: IntuneService,
    private cdrRef: ChangeDetectorRef,
    private drivePickerService: DrivePickerService,
    private modalController: ModalController,
    private popoverController: PopoverController,
    private router: Router,
    private toastService: ToastService,
    private translateService: TranslateService
  ) {
    this.msalService.instance.setNavigationClient(
      new CustomNavigationClient(this.iab, this.sharedSvc)
    );
    this.appVersion = this.webAppInfo.appVersion;
    this.updatePwaServiceService.checkForUpdates();
  }

  initGoogleLogin() {
    let scopes = [
      'openid',
      'https://www.googleapis.com/auth/userinfo.email',
      'https://www.googleapis.com/auth/userinfo.profile',
      'https://www.googleapis.com/auth/gmail.readonly',
      'https://www.googleapis.com/auth/drive.file',
    ];

    GoogleAuth.initialize({
      clientId: environment.GAPI_CLIENT_ID,
      scopes,
      grantOfflineAccess: true,
    });
    this.drivePickerService.pickerInit();
  }

  getCloudStorageConfig() {
    this.subscription = this.intuneService.mobileConfigurationSubject$.subscribe(
      (mobileConfig: MobileConfiguration) => {
        if (mobileConfig?.hasOwnProperty('CloudStorageToggle')) {
          this.cloudStorageToggle =
            mobileConfig && mobileConfig?.CloudStorageToggle === false ? false : true;
        }
        if (mobileConfig?.CloudStorage && typeof mobileConfig.CloudStorage === 'object') {
          this.accountPages.forEach((data) => {
            data.isVisible = mobileConfig.CloudStorage[data.label] === false ? false : true;
          });
        } else {
          this.accountPages.map((data) => {
            data.isVisible = true;
            return data;
          });
          this.cloudStorageToggle = mobileConfig?.CloudStorage === false ? false : true;
        }
        this.cdrRef.detectChanges();
      }
    );
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  async ngOnInit() {
    await this.platform
      .ready()
      .then(async () => {
        //setting language
        this.languageService.setInitialAppLanguage();
        this.registerHardwareBackButton();
        await this.domainSvc.loadDomainInfo();
        if (this.platform.is('capacitor')) {
          await this.firebaseCrashlyticsService.setEnabled();
        } else {
          this.route.queryParams.subscribe((params) => {
            this.domainSvc.handleParams(params);
          });
        }

        this.initGoogleLogin();
        await this.intuneService.setLatestMdmProfile();
        if (this.platform.is('capacitor')) {
          await this.intuneService.loadIntuneConfig();
        }
        this.getCloudStorageConfig();
      })
      .catch();
    this.addAppStateChangeListner();
    if (this.platform.is('capacitor')) {
      App.getInfo()
        .then((data) => {
          this.appVersion = data.version;
        })
        .catch();
    }
    // setting account only value
    const getAccountVal = await this.loginAccountService.getAccountOnly();
    if (getAccountVal) {
      this.sharedSvc.accountOnly = JSON.parse(getAccountVal)?.value ?? false;
    }

    this.deviceInfo = await Device.getInfo();
    // const appInfo = await App.getInfo();
    await this.doCheckStorageAccountStatus();
    this.sharedSvc.checkStorageAccountStatus.subscribe((event) => {
      if (event) {
        this.doCheckStorageAccountStatus();
      }
    });
    this.accountSvc.accountStateChanged.subscribe((account) => {
      switch (account[0]) {
        case 'Box':
          if (this.accountPages[0].isEnabled !== account[1]) {
            this.accountPages[0].isEnabled = account[1];
          }
          break;
        case 'One Drive':
          if (this.accountPages[1].isEnabled !== account[1]) {
            this.accountPages[1].isEnabled = account[1];
          }
          break;
        case 'Drop Box':
          if (this.accountPages[2].isEnabled !== account[1]) {
            this.accountPages[2].isEnabled = account[1];
          }
          break;
        case 'Office 365':
          if (this.accountPages[3].isEnabled !== account[1]) {
            this.accountPages[3].isEnabled = account[1];
          }
          break;
      }
    });

    this.accountSvc.redirectedAccount.subscribe(async (refreshAccounts) => {
      if (refreshAccounts) {
        this.accountPages[0].isEnabled = (await this.accountSvc.getBoxAccount()) ? true : false;
        this.accountPages[1].isEnabled = (await this.accountSvc.getOneDriveAccount())
          ? true
          : false;
        this.accountPages[2].isEnabled = (await this.accountSvc.getDropBoxAccount()) ? true : false;
        this.accountPages[3].isEnabled = (await this.accountSvc.getOffice365Account())
          ? true
          : false;
      }
    });

    this.broadcastService.msalSubject$
      .pipe(
        filter(
          (msg: EventMessage) =>
            msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
            msg.eventType === EventType.LOGIN_SUCCESS
        ), //
        takeUntil(this._destroying$)
      )
      .subscribe(
        async (result: EventMessage) => {
          console.log('Microsoft login response ====>', result);

          // Do something with event payload here
          const service = await this.storageSvc.get('msal-login');
          if (service === 'onedrive' || service === 'office365') {
            await this.storageSvc.remove('msal-login');
            const payload: any = result.payload;
            this.storageSvc.set(service + '-account-id', payload?.account?.username);
            this.navCtrl.navigateForward('app/add-files/onedrive-list');
          } else if (service === 'hotmail' || service === 'outlook' || service === 'office') {
            this.storageSvc.remove('msal-login');
            const payload: any = result.payload;
            //email-hotmail-id
            const id = payload?.account?.username ?? '';
            this.storageSvc.set(service, payload?.account?.username);
            await this.accounts.setEmailAccount(id, service, {
              email: payload?.account?.username,
            });
            this.navCtrl.navigateForward('app/add-files/email-accounts');
          }
        },
        (error) => {
          console.log('error ====>', error);
        }
      );
  }
  addAppStateChangeListner() {
    App.addListener('appStateChange', async ({ isActive }) => {
      if (isActive) {
        this.doCheckStorageAccountStatus();
      }
    });
  }
  async doCheckStorageAccountStatus() {
    let promises = await Promise.all([
      await this.accountSvc.getBoxAccount(),
      await this.accountSvc.getOneDriveAccount(),
      await this.accountSvc.getDropBoxAccount(),
      await this.accountSvc.getOffice365Account(),
    ]);
    this.zone.run(async () => {
      this.accountPages.forEach((account, index) => {
        account.isEnabled = promises[index] ? true : false;
      });
    });
  }

  async switchToggle(title: string, enabled: boolean) {
    const toggle = false;
    switch (title) {
      case 'One Drive':
        if (((await this.accountSvc.getOneDriveAccount()) ? true : false) !== enabled) {
          this.accountSvc.accountStateChanged.next([title, enabled]);
          if (enabled) {
            this.menuCtrl.close();
          }
        }
        break;
      case 'Box':
        if (((await this.accountSvc.getBoxAccount()) ? true : false) !== enabled) {
          this.accountSvc.accountStateChanged.next([title, enabled]);
          if (enabled) {
            this.menuCtrl.close();
          }
        }
        break;
      case 'Drop Box':
        if (((await this.accountSvc.getDropBoxAccount()) ? true : false) !== enabled) {
          this.accountSvc.accountStateChanged.next([title, enabled]);
          if (enabled) {
            this.menuCtrl.close();
          }
        }
        break;
      case 'Office 365':
        if (((await this.accountSvc.getOffice365Account()) ? true : false) !== enabled) {
          this.accountSvc.accountStateChanged.next([title, enabled]);
          if (enabled) {
            this.menuCtrl.close();
          }
        }
        break;
    }
    return toggle;
  }

  navigateToAbout() {
    this.navCtrl.navigateForward('about-page');
  }
  navigateToAccounts() {
    this.navCtrl.navigateForward('accounts');
  }
  navigateToLanguages() {
    this.navCtrl.navigateForward('language');
  }
  accountOnlyHandler() {
    this.sharedSvc.accountOnly = !this.sharedSvc.accountOnly;
    this.loginAccountService.setAccountOnly(this.sharedSvc.accountOnly);
  }
  supportMailTo() {}

  async navigateToSelectAccount(type) {
    const accountList = this.loginAccountService.authenticatedAccount$.getValue();
    if (accountList.length === 1) {
      const allAccount = (await this.loginAccountService.read()) ?? [];
      allAccount.map((acc, i) => (acc.activeAccount = !!acc?.ssoConfirmationResp));
      await this.loginAccountService.update(allAccount);
      this.navCtrl.navigateForward(type);
    } else {
      this.navCtrl.navigateForward('select-account', {
        state: type,
      });
    }
  }

  public registerHardwareBackButton() {
    this.platform.backButton.subscribeWithPriority(0, async () => {
      let isModalClosed = false;
      let isPopOverClosed = false;
      if (await this.modalController?.getTop()) {
        const modal = await this.modalController.getTop();
        if (modal) {
          this.modalController.dismiss();
          isModalClosed = true;
        }
      }
      if (await this.popoverController?.getTop()) {
        const popover = await this.popoverController.getTop();
        if (popover) {
          this.popoverController.dismiss();
          isPopOverClosed = true;
        }
      }
      if (!isModalClosed && !isPopOverClosed) {
        if (this.routerOutlet && this.routerOutlet.canGoBack()) {
          this.backCount = 0;
          this.routerOutlet.pop();
        } else if (this.router.url === '/app/add-files') {
          if (this.backCount == 0) {
            this.backCount++;
            this.toastService.presentToast(this.translateService.instant('PRESS_AGAIN'), 2000);
          } else if (this.backCount == 1) {
            App.exitApp();
          }
          setTimeout(() => {
            this.backCount = 0;
          }, 3000);
        }
      }
    });
  }
}
